import { render, staticRenderFns } from "./RegisterNewAccountView.vue?vue&type=template&id=409e47c8&scoped=true&"
import script from "./RegisterNewAccountView.vue?vue&type=script&lang=ts&"
export * from "./RegisterNewAccountView.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterNewAccountView.vue?vue&type=style&index=0&id=409e47c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409e47c8",
  null
  
)

export default component.exports